import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnContentType } from './content-type';
import { getContentTypeIcon } from './content-type-icon';

export class SnObjectInfo extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public contentType: SnContentType;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }

  get icon(): string {
    return getContentTypeIcon(this.contentType);
  }
}
